module.exports = __webpack_public_path__ + "assets/img/NPC015.d1bd0d13.png";